// extracted by mini-css-extract-plugin
module.exports = {"card":"user-menu_card__Im9jY","header":"user-menu_header__3fsBb","menu":"user-menu_menu__2StYo","textEllipsis":"user-menu_textEllipsis__2s_Al"};